import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "board_graph_list wordcloud_graph" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.props.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($setup.chartData)
            ? (_openBlock(), _createBlock(_component_Chart, {
                key: 0,
                style: {"min-height":"400px"},
                defaultLayout: $setup.chartLayout,
                data: $setup.chartData
              }, null, 8, ["defaultLayout", "data"]))
            : (_openBlock(), _createBlock(_component_NoResult, { key: 1 }))
        ], 64))
      : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
  ]))
}